import { SESSIONS_TABLE_SIZES } from "@pages/analytics/constants";

export const SessionTableRowSkeleton = () => {
  return (
    <div className="tw-flex tw-items-center tw-bg-white tw-border-b tw-border-solid tw-border-blue-100 tw-py-0.5 tw-min-h-[53px] last:tw-border-b-0">
      {/* Reader column */}
      <div className="tw-flex-auto tw-px-2 tw-pl-4 tw-py-2 tw-flex tw-items-center tw-min-w-0">
        <div className="tw-flex tw-flex-col tw-gap-2 tw-justify-center tw-min-w-0 tw-w-full">
          <div className="tw-h-4 tw-bg-blue-100 tw-rounded tw-w-32 tw-animate-pulse" />
          <div className="tw-h-3 tw-bg-blue-50 tw-rounded tw-w-48 tw-animate-pulse" />
        </div>
      </div>

      {/* Session started column */}
      <div
        className="tw-px-2 tw-flex tw-items-center tw-h-[53px]"
        style={{ width: SESSIONS_TABLE_SIZES.SESSION_STARTED }}
      >
        <div className="tw-h-4 tw-bg-blue-100 tw-rounded tw-w-24 tw-animate-pulse" />
      </div>

      {/* Reading time column */}
      <div
        className="tw-px-2 tw-flex tw-items-center tw-h-[53px]"
        style={{ width: SESSIONS_TABLE_SIZES.READING_TIME }}
      >
        <div className="tw-h-4 tw-bg-blue-100 tw-rounded tw-w-12 tw-animate-pulse" />
      </div>

      {/* Clicked CTA column */}
      <div
        className="tw-px-2 tw-flex tw-items-center tw-h-[53px]"
        style={{ width: SESSIONS_TABLE_SIZES.CLICKED_CTA }}
      >
        <div className="tw-size-6 tw-bg-blue-100 tw-rounded tw-animate-pulse" />
      </div>

      {/* Progress column */}
      <div
        className="tw-px-2 tw-flex tw-items-center tw-h-[53px]"
        style={{ width: SESSIONS_TABLE_SIZES.PROGRESS }}
      >
        <div className="tw-flex tw-items-center tw-gap-2">
          <div className="tw-size-6 tw-bg-blue-100 tw-rounded-full tw-animate-pulse" />
          <div className="tw-h-4 tw-bg-blue-100 tw-rounded tw-w-12 tw-animate-pulse" />
        </div>
      </div>

      {/* Location column */}
      <div
        className="tw-px-2 tw-flex tw-items-center tw-h-[53px]"
        style={{ width: SESSIONS_TABLE_SIZES.LOCATION }}
      >
        <div className="tw-h-4 tw-bg-blue-100 tw-rounded tw-w-20 tw-animate-pulse" />
      </div>

      {/* Device column */}
      <div
        className="tw-px-2 tw-pr-4 tw-flex tw-items-center tw-justify-between tw-h-[53px]"
        style={{ width: SESSIONS_TABLE_SIZES.DEVICE }}
      >
        <div className="tw-flex tw-items-center tw-gap-2.5">
          <div className="tw-size-4 tw-bg-blue-100 tw-rounded tw-animate-pulse" />
          <div className="tw-h-4 tw-bg-blue-100 tw-rounded tw-w-16 tw-animate-pulse" />
        </div>
        <div className="tw-size-4 tw-bg-blue-100 tw-rounded tw-animate-pulse" />
      </div>
    </div>
  );
};
